var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-pram",class:_vm.classes},[_c('span',{staticClass:"block-pram__body"}),_c('span',{staticClass:"block-pram__weel block-pram--weel-left"}),_c('span',{staticClass:"block-pram__weel block-pram--weel-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }